/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { SvenskdamStandaloneNewsletterSignup as ResolvedStandaloneNewsletterSignup } from 'sites/svenskdam/components/standalone/NewsletterSignup';

export const NewsletterSignup: typeof ResolvedStandaloneNewsletterSignup = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneNewsletterSignup {...props} />
    );
});

export type NewsletterSignupProps = PropsFromComponent<typeof NewsletterSignup>;

/** @deprecated Use slot architecture instead */
export const NewsletterSignupWith = (extras: DynamicStandaloneExtras): typeof NewsletterSignup => {
    return function NewsletterSignup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'NewsletterSignup');
        return <ResolvedStandaloneNewsletterSignup {...mergeProps({ options: { theme } }, props)} />;
    }
}